import { SiteListBase } from "@Base/Site/SiteListBase";

import "./SiteList.scss";

export class SiteList extends SiteListBase
{
	constructor()
	{
		super();
	}
}